define('NetSuite.SuiteCommCPQ.Main.View.QuickAdd', [
        'netsuite_suitecommcpq_main_quickadd.tpl',
        'Utils', 'Backbone', 'jQuery', 'underscore', 'NetSuite.SuiteCommCPQ.Main.Configuration',
        'NetSuite.SuiteCommCPQ.Main.Core', 'NetSuite.SuiteCommCPQ.Main.Debug',
    ],
    function(netsuite_suitecommcpq_main_quickadd_tpl, Utils, Backbone, jQuery, _, Configuration, Core, Debugger) {
        'use strict';
        var selectedItem,
            matrixSelRequired,
            showQuantity,
            genericProductId;
        // @class NetSuite.SuiteCommCPQ.Main.View.Sku @extends Backbone.View
        return Backbone.View.extend({
            template: netsuite_suitecommcpq_main_quickadd_tpl,
            initialize: function(options) {
                Debugger.log('VCPQ','QuickAddView : init');
                var cart = options.container.getComponent('Cart');
                if (!cart) {
                    return;
                }
                var configEnabled = Configuration.get('isConfigEnabled'),
                    onlyConfigurable = Configuration.get('onlyConfigurable'),
                    allowAddToCartForLinkedConfigurableItems = Configuration.get('addConfigurableLinked'),
                    allowAddToCartForGenericConfigurableItems = Configuration.get('addConfigurableGen'),
                    configureButton,
                    addItemButton,
                    cartDetailedViewInstance;
                genericProductId = Configuration.get('allConfigurable');
                matrixSelRequired = Configuration.get('matrixSelRequired');
                showQuantity = Configuration.get('showQuantity');
                cart.on('afterShowContent', function () {
                    cartDetailedViewInstance = options.container.getLayout().getCurrentView();
                    cartDetailedViewInstance.on('afterCompositeViewRender', init, this);
                    init();
                });
                function init() {
                    var quickAddViewInstance = cartDetailedViewInstance.getChildViewInstance('Quick.Order').getChildViewInstance('QuickAddView');
                    quickAddViewInstance.itemsSearcherComponent.on("itemSelected", onItemSelected, this);
                    addItemButton = jQuery('[data-view=QuickAddView] form [type=submit]');
                    configureButton = jQuery('#quickadd-configure');
                    configureButton.on('click', function() {
                        cpqOpenConfig();
                    });
                    configureButton.insertAfter(addItemButton);
                }
                function onItemSelected(event) {
                    if (!event.selectedItem) {
                        selectedItem = null;
                        addItemButton.show();
                        hideConfigureButton();
                        return;
                    }
                    var itemModel = event.selectedItem.getItem();
                    selectedItem = {
                        internalid: itemModel.get('internalid'),
                        custitem_scpq_item_product_id: itemModel.get('custitem_scpq_item_product_id'),
                        custitem_scpq_item_isconf: itemModel.get('custitem_scpq_item_isconf')
                    };
                    if (itemModel.getSelectedMatrixChilds) {
                        selectedItem.selectedMatrixChilds = itemModel.getSelectedMatrixChilds();
                    }
                    if (isAllowAddToCart(selectedItem)) {
                        addItemButton.show();
                    } else {
                        addItemButton.hide();
                    }
                    if (isConfigurable(selectedItem)) {
                        showConfigureButton();
                    } else {
                        hideConfigureButton();
                    }
                }
                function showConfigureButton() {
                    setConfigureButtonMargin();
                    configureButton.show();
                }
                function hideConfigureButton() {
                    setConfigureButtonMargin();
                    configureButton.hide();
                }
                function setConfigureButtonMargin() {
                    if (addItemButton.is(':hidden')) {
                        configureButton.css('margin-left', '0');
                    } else {
                        configureButton.css('margin-left', '15px');
                    }
                }
                function isConfigurable(item) {
                    return configEnabled &&
                        (
                            item.custitem_scpq_item_product_id // cpq product ID assigned
                            || (genericProductId && (!onlyConfigurable || item.custitem_scpq_item_isconf)) // all configurable or this one is configurable
                        )
                }
                function isAllowAddToCart(selectedItem) {
                    if (isConfigurable(selectedItem)) {
                        if (allowAddToCartForLinkedConfigurableItems && selectedItem.custitem_scpq_item_product_id) {
                            return true;
                        } else if (allowAddToCartForGenericConfigurableItems && (genericProductId && (!onlyConfigurable || selectedItem.custitem_scpq_item_isconf))) {
                            return true;
                        }
                        return false;
                    }
                    return true;
                }
            },
            bindings: {},
            childViews: {
            },
            loaded: function loaded() {},
            //@method getContext @return NetSuite.SuiteCommCPQ.Main.View.Sku.Context
            getContext: function getContext() {
                //@class VT.VGen.VModule.View.Context
                return {};
            },
            quickadd_config_run: function () {
                cpqOpenConfig();
            }
        });
        function cpqOpenConfig() {
            Debugger.log('VCPQ','View : cpqOpenConfig');
            var productId, intId, configId = null, matrix, mChilds = '', isMatrix, quantity = 1;
            //
            if (selectedItem) {
                quantity = getQuantity() || quantity;
                productId = selectedItem.custitem_scpq_item_product_id;
            }
            if (!productId) {
                productId = genericProductId; // = 1
            }
            if (!productId) {
                Debugger.error('Config Product is not specified');
                return ;
            }
            // set item internal ID (optional)
            intId = selectedItem.internalid;
            matrix = selectedItem.selectedMatrixChilds;
            isMatrix = !!(matrix && matrix.length);
            if (matrix && matrix.length == 1) {
                mChilds += matrix[0].internalid;
            }
            Debugger.log('VCPQ', 'View : Open config ID = ' + productId);
            if (!isMatrix || (mChilds || !matrixSelRequired)) {
                var launchData = {
                    productid: productId,
                    intid: intId,
                    configid: configId,
                    mchilds: mChilds
                };
                if (showQuantity) {
                    launchData.qty = quantity;
                }
                Core.launchConfig(launchData);
            } else {
                alert('Please select item options');
            }
        }
        // The quantity value in the QuickAdd.Model is not updated until "Add Item" submit occurs.
        // Therefore, the only way to get quantity is through the DOM
        function getQuantity() {
            var formElement = jQuery('[data-view=QuickAddView] form');
            var formData = formElement.serializeObject();
            return formData ? formData.quantity : null;
        }
    });
